module.exports = __webpack_public_path__ + "img/20191002133557360截图20191002132943181.8e0af2ca.jpg";